<button
	mat-raised-button
	type="button"
	(click)="onSubmitReview()"
	[disabled]="status.status === 'UNDER_REVIEW' || !status.ok"
	color="primary"
>
	<span>Enviar a revisión</span>
</button>
